import React from "react";
import { useTranslation } from "react-i18next";
import { FileUploader } from "../../common/FileUploader";

export function ImageUploadSection({ imageUrl, setField }) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <FileUploader
        label={t("uploadImage")}
        onUploadComplete={key => setField("imageUrl", key)}
        t={t}
        previewEnabled={true}
        initialKey={imageUrl}
        required
      />
      {imageUrl && (
        <div className="mt-1">
          <span className="text-sm">{t("uploadedKey")}:</span>{" "}
          <code>{imageUrl}</code>
        </div>
      )}
    </div>
  );
}